import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.SpacePort;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "SpacePort.Phaser.IntroductionScene.1",
            "SpacePort.Phaser.IntroductionScene.2",
            "SpacePort.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/SpacePortGame/scenes/GameIntro.ts